import type { LucideIcon } from "lucide-react";
import {
  CheckCircle2,
  Clipboard,
  Dumbbell,
  GraduationCap,
  FileText,
  MessageSquare,
} from "lucide-react";

export type ProfileSectionValue =
  | "checklist"
  | "onboarding"
  | "equipment"
  | "trainer"
  | "workouts"
  | "files"
  | "notes"
  | "legal";

export type ProfileSection = {
  value: ProfileSectionValue;
  label: string;
  icon: LucideIcon;
  highlight?: boolean;
};

export const PROFILE_SECTIONS: ProfileSection[] = [
  { value: "checklist", label: "Checklist", icon: CheckCircle2, highlight: true },
  { value: "onboarding", label: "Onboarding", icon: Clipboard },
  { value: "equipment", label: "Equipment", icon: Dumbbell },
  { value: "trainer", label: "Trainer", icon: GraduationCap },
  { value: "workouts", label: "Workouts", icon: Dumbbell },
  { value: "files", label: "Files", icon: FileText },
  { value: "notes", label: "Notes", icon: MessageSquare },
  { value: "legal", label: "Legal", icon: FileText },
];

export const VALID_PROFILE_TABS = new Set<string>(
  PROFILE_SECTIONS.map((section) => section.value)
);

export function getProfileSection(value: string): ProfileSection | undefined {
  return PROFILE_SECTIONS.find((section) => section.value === value);
}

export function isSectionDisabled(
  sectionValue: ProfileSectionValue,
  legalApprovalNeeded: boolean
): boolean {
  return legalApprovalNeeded && sectionValue !== "legal";
}
